<form [formGroup]="form">
  <div class="row">
    <div class="col">
      <frm-text
        i18n-label="@@WawiApiNoteFacilityUpdateForm_Note"
        label="Note"
        formControlName="note"
        [multiline]="true"
        [rows]="8"
      ></frm-text>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <frm-check
        i18n-label="@@WawiApiNoteFacilityUpdateForm_DisplayLevelMobile"
        label="Display on mobile app"
        formControlName="displayLevelMobile"
        [trueValue]="noteDisplayLevelMobileType.Display"
        [falseValue]="noteDisplayLevelMobileType.DontDisplay"
      ></frm-check>
    </div>
    <div class="col">
      <frm-check
        i18n-label="@@WawiApiNoteFacilityUpdateForm_Acknowledged"
        label="Mark as read on mobile app"
        formControlName="acknowledgedOnMobile"
        [trueValue]="noteAcknowledged.Acknowledged"
        [falseValue]="noteAcknowledged.Unread"
      ></frm-check>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label i18n="Anzeigestufe@@WawiApiNoteFacilityUpdateForm_DisplayLevel">DisplayLevel</mat-label>
        <mat-select formControlName="displayLevel" >
          @for (item of displayLevel; track item) {
            <mat-option
              [value]="item.value">
              {{item.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</form>
